// extracted by mini-css-extract-plugin
module.exports = {"aSlide":"SwiperPeopleStylesFlat_aSlide__BAjPN","profile_holder":"SwiperPeopleStylesFlat_profile_holder__BBMLJ"};